import { render, staticRenderFns } from "./drink.vue?vue&type=template&id=6e382392&"
import script from "./drink.vue?vue&type=script&lang=js&"
export * from "./drink.vue?vue&type=script&lang=js&"
import style0 from "./drink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListGoods: require('/home/runner/work/myody_front/myody_front/components/list/ListGoods.vue').default,Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default,CardContact: require('/home/runner/work/myody_front/myody_front/components/card/CardContact.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
